// Script di calcolo degli sconti
// Adattato per Madrespera - Luca Siviero

document.addEventListener("customily:ready", async () => {
    const eligibleCollectionId = 530342838540;
    const collectionIds = window.productCollectionIds || [];

    const isEligible = collectionIds.some((id) => id == eligibleCollectionId);

    if (!isEligible) return;

    // Wrappa fetch e XHR SOLO su pagine eleggibili e DOPO il check
    const originalFetch = window.fetch;
    window.fetch = function () {
        return originalFetch.apply(this, arguments).then(async (response) => {
            if (response.url.includes('/cart/') && !response.url.includes('cart.js')) {
                setTimeout(syncCartAndQty, 600);
            }
            return response;
        });
    };

    const open = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function () {
        this.addEventListener("load", () => {
            if (this.responseURL.includes('/cart/') && !this.responseURL.includes('cart.js')) {
                setTimeout(syncCartAndQty, 600);
            }
        });
        open.apply(this, arguments);
    };

    // RECUPERO QUANTITA' CARRELLO
    // NOTA: /cart.js non espone le collection del prodotto, quindi qui il check di eleggibilita'
    // si basa sulla presenza della property scritta da Customily stesso (_customily-thumb)
    let cartQty = 0;
    try {
        const res = await fetch('/cart.js');
        const cart = await res.json();
        cart.items.forEach(item => {
            if (item.properties && item.properties["_customily-thumb"]) {
                cartQty += item.quantity;
            }
        });
    } catch (e) { console.error("Errore fetch carrello", e); }

    // Madrespera: selettori del nuovo tema (custom elements)
    const qtyInput = document.querySelector("quantity-selector input[name='quantity']");
    const picker = document.querySelector("quantity-selector");
    const priceEl = document.querySelector(".product price-list sale-price");

    if (!qtyInput || !picker || !priceEl) return;

    // Box principale
    const box = document.createElement("div");
    box.id = "wr-discount-box";
    box.style.marginTop = "10px";
    box.style.fontSize = "16px";
    box.style.textAlign = "center";
    box.style.fontWeight = "600";
    box.style.lineHeight = "1.5";
    box.style.position = "relative";
    const insertionPoint = document.querySelector('[data-block-type="quantity-selector"]') || picker;
    insertionPoint.insertAdjacentElement("afterend", box);

    // Bottone info
    const infoBtn = document.createElement("button");
    infoBtn.type = "button";
    infoBtn.textContent = "Info sconti";
    infoBtn.style.display = "inline-block";
    infoBtn.style.marginTop = "2px";
    infoBtn.style.marginBottom = "6px";
    infoBtn.style.fontSize = "14px";
    infoBtn.style.border = "none";
    infoBtn.style.background = "none";
    infoBtn.style.color = "#000";
    infoBtn.style.cursor = "pointer";
    infoBtn.style.textDecoration = "underline";

    // Modal sconti
    const modal = document.createElement("div");
    modal.style.position = "fixed";
    modal.style.top = "0";
    modal.style.left = "0";
    modal.style.width = "100%";
    modal.style.height = "100%";
    modal.style.background = "rgba(0,0,0,0.6)";
    modal.style.display = "none";
    modal.style.alignItems = "center";
    modal.style.justifyContent = "center";
    modal.style.zIndex = "1000001";

    const modalContent = document.createElement("div");
    modalContent.style.background = "#fff";
    modalContent.style.padding = "20px";
    modalContent.style.marginLeft = "10px";
    modalContent.style.marginRight = "10px";
    modalContent.style.borderRadius = "2px";
    modalContent.style.maxWidth = "320px";
    modalContent.style.width = "90%";
    modalContent.style.textAlign = "center";
    modalContent.style.boxShadow = "0 2px 20px rgba(0,0,0,0.2)";
    modalContent.innerHTML = `
        <h3 style="margin-bottom:10px;">Tabella sconti</h3>
        <table style="width:100%;border-collapse:collapse;font-size:14px;">
            <tr><td>1 articolo</td><td>Prezzo pieno</td></tr>
            <tr><td>2 articoli</td><td>-10%</td></tr>
            <tr><td>3-4 articoli</td><td>-15%</td></tr>
            <tr><td>5–9 articoli</td><td>-20%</td></tr>
            <tr><td>10–19 articoli</td><td>-25%</td></tr>
            <tr><td>20–34 articoli</td><td>-30%</td></tr>
            <tr><td>35–49 articoli</td><td>-40%</td></tr>
            <tr><td>50+ articoli</td><td>-50%</td></tr>
        </table>
        <button id="closeModalBtn" type="button" style="
            margin-top:15px;
            background:#000;
            color:#fff;
            padding:8px 16px;
            border: 1px solid #000;
            cursor:pointer;
        ">Chiudi</button>
    `;

    modal.appendChild(modalContent);
    document.body.appendChild(modal);

    infoBtn.addEventListener("click", () => {
        modal.style.display = "flex";
    });
    modal.addEventListener("click", (e) => {
        if (e.target === modal) modal.style.display = "none";
    });
    modalContent
        .querySelector("#closeModalBtn")
        .addEventListener("click", () => (modal.style.display = "none"));

    // Contenitore per i testi dei prezzi
    const priceDetails = document.createElement("div");

    // Barra progresso e Messaggio
    const progressMsg = document.createElement("div");
    progressMsg.style.cssText = "font-size: 13px; color: #555; margin: 10px 0 5px; font-weight: 400;";

    const progressContainer = document.createElement("div");
    progressContainer.style.cssText = "width: 100%; background: #eee; border-radius: 10px; height: 10px; overflow: hidden; border: 1px solid #ddd; margin-bottom: 10px;";

    const progressBar = document.createElement("div");
    progressBar.style.cssText = "width: 0%; height: 100%; background: #28a745; transition: width 0.3s ease;";

    progressContainer.appendChild(progressBar);

    box.appendChild(priceDetails);
    box.appendChild(infoBtn);
    box.appendChild(progressMsg);
    box.appendChild(progressContainer);

    function getDiscount(qty) {
        if (qty >= 50) return 50;
        if (qty >= 35) return 40;
        if (qty >= 20) return 30;
        if (qty >= 10) return 25;
        if (qty >= 5) return 20;
        if (qty >= 3) return 15;
        if (qty >= 2) return 10;
        return 0;
    }

    function formatPrice(num) {
        return num.toLocaleString("it-IT", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        });
    }

    function getBasePrice() {
        // Madrespera: niente data-attribute sul prezzo, leggiamo dal testo di <sale-price>
        // Formato atteso tipo "€59,90"
        const raw = priceEl.textContent || "";
        const cleaned = raw.replace(/[^\d,.-]/g, "").replace(",", ".");
        return parseFloat(cleaned) || 0;
    }

    let eligibleItems = []; // Array per salvare i prezzi base di ogni riga del carrello
    let cartIneligibleTotal = 0;

    async function syncCartAndQty() {
        try {
            const res = await fetch('/cart.js?t=' + Date.now());
            const cart = await res.json();

            eligibleItems = []; // Resettiamo l'array
            cartIneligibleTotal = 0;
            let newCartQty = 0;

            cart.items.forEach(item => {
                // Eleggibilita' basata sulla property scritta da Customily (niente collections in /cart.js)
                const isPersonalizzato = !!(item.properties && item.properties["_customily-thumb"]);

                if (isPersonalizzato) {
                    eligibleItems.push({
                        basePrice: (item.original_price || item.price) / 100,
                        qty: item.quantity
                    });
                    newCartQty += item.quantity;
                } else {
                    cartIneligibleTotal += (item.final_line_price / 100);
                }
            });

            cartQty = newCartQty;
            update();
        } catch (e) { console.error("Errore sync", e); }
    }

    document.addEventListener('click', (e) => {
        if (e.target.closest('[name="add"], .js-qty-button, .cart__qty-btn, quantity-selector button')) {
            setTimeout(syncCartAndQty, 1000);
        }
    });

    function update() {
        const inputQty = Math.max(1, parseInt(qtyInput.value || 1));
        const totalQtyForDiscount = inputQty + cartQty;
        const discount = getDiscount(totalQtyForDiscount);
        const currentPdpBasePrice = getBasePrice();

        // A. Calcolo scontato per l'articolo che l'utente sta guardando (PDP)
        const discountedPriceUnit = Math.round(currentPdpBasePrice * (1 - discount / 100) * 100) / 100;
        const pdpRowTotal = discountedPriceUnit * inputQty;

        // B. Calcolo scontato per ogni riga gia' nel carrello
        let cartEligibleTotalDiscounted = 0;
        eligibleItems.forEach(item => {
            const itemDiscountedPrice = Math.round(item.basePrice * (1 - discount / 100) * 100) / 100;
            cartEligibleTotalDiscounted += (itemDiscountedPrice * item.qty);
        });

        // C. Totale Finale (Arrotondato per sicurezza contro errori floating point di JS)
        const totalOrder = Math.round((pdpRowTotal + cartEligibleTotalDiscounted + cartIneligibleTotal) * 100) / 100;

        // --- GESTIONE MESSAGGI E PROGRESS BAR ---
        const tiers = [2, 3, 5, 10, 20, 35, 50];
        const nextTier = tiers.find(t => t > totalQtyForDiscount);
        if (nextTier) {
            const itemsNeeded = nextTier - totalQtyForDiscount;
            progressMsg.innerHTML = `Ti <strong>${itemsNeeded === 1 ? 'manca' : 'mancano'} ${itemsNeeded}</strong> ${itemsNeeded === 1 ? 'articolo' : 'articoli'} per il <strong>-${getDiscount(nextTier)}%</strong>`;
            const prevTier = [...tiers].reverse().find(t => t <= totalQtyForDiscount) || 0;
            let progress = ((totalQtyForDiscount - prevTier) / (nextTier - prevTier)) * 100;
            progressBar.style.width = `${Math.max(20, progress)}%`;
        } else {
            progressMsg.innerHTML = "🎉 Massimo sconto raggiunto!";
            progressBar.style.width = "100%";
        }

        const customilyModal = document.querySelector('.customily-modal-container');
        // Se la modale esiste E il suo display non e' "none", allora Customily e' attivo
        const isCustomilyActive = customilyModal && customilyModal.style.display !== 'none';

        // --- DISPLAY ---
        priceDetails.innerHTML = `
            ${discount > 0 ? `<div><strong>SCONTO APPLICATO: -${discount}%</strong></div>` : ''}
            <div>€${formatPrice(discountedPriceUnit)} cad. ${discount > 0 ? `(invece di €${formatPrice(currentPdpBasePrice)})` : ''}</div>
            ${isCustomilyActive ? `<div><strong>TOTALE ORDINE: €${formatPrice(totalOrder)}</strong></div>` : ``}
        `;
    }

    qtyInput.addEventListener("input", update);
    document
        .querySelectorAll(".js-quantity-button-pdp, quantity-selector button")
        .forEach((btn) => btn.addEventListener("click", () => setTimeout(update, 50)));

    const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
            if (mutation.attributeName === 'style') {
                update();
            }
        });
    });

    const targetModal = document.querySelector('.customily-modal-container');
    if (targetModal) {
        observer.observe(targetModal, { attributes: true });
    } else {
        // Se Customily carica in ritardo, riprovo a cercare il modal ogni secondo per 5 secondi
        let attempts = 0;
        const interval = setInterval(() => {
            const retryModal = document.querySelector('.customily-modal-container');
            if (retryModal) {
                observer.observe(retryModal, { attributes: true });
                clearInterval(interval);
            }
            if (++attempts > 5) clearInterval(interval);
        }, 1000);
    }

    syncCartAndQty();
});